import { type GenerateGatewayUrlParams, useLogger } from '@capsicum/common';
import { useCallback, useState } from 'react';

import { useGenerateWebLinkToGateway } from './useGenerateWebLinkToGateway';

type NavigateToGatewayShape = {
	gatewayWebLinkParams: GenerateGatewayUrlParams;
	navigate: (gatewayWebLink: string) => void;
};

const TIMEOUT_FOR_NEW_LINK = 3000;

export const useNavigateToGateway = () => {
	const [isGenerating, setIsGenerating] = useState(false);

	const logger = useLogger();

	const { generateWebLinkToGateway } = useGenerateWebLinkToGateway();

	const navigateToGateway = useCallback(
		async ({ gatewayWebLinkParams, navigate }: NavigateToGatewayShape) => {
			if (isGenerating) return;

			try {
				setIsGenerating(true);
				const gatewayWebLink = await generateWebLinkToGateway(gatewayWebLinkParams);

				if (gatewayWebLink) navigate(gatewayWebLink);
			} catch (error) {
				logger.error(`Navigation to gateway failed: ${error}`);
			} finally {
				setTimeout(() => {
					setIsGenerating(false);
				}, TIMEOUT_FOR_NEW_LINK);
			}
		},
		[isGenerating, generateWebLinkToGateway]
	);

	return { navigateToGateway };
};
